import React, { Component } from 'react';
import { withNamespaces } from 'react-i18next';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { AvField, AvForm } from 'availity-reactstrap-validation';
import SweetAlert from 'react-bootstrap-sweetalert';
import { Button, Card, CardBody, CardTitle, Col, FormGroup, Label, Table } from 'reactstrap';

import {
  getDmxProfileById,
  getDmxDevicePresetById,
  createDmxDevicePreset,
  updateDmxDevicePreset,
} from '../../store/actions';

// AA-11839 / unificación DMX: formulario generado dinámicamente a partir de
// los canales del perfil asignado al dispositivo (dmx_device_profile_channels),
// en vez de un formulario con campos fijos como tenía el viejo modelo de
// Foco/Posición.
function buildChannelValues(channels, existingValues) {
  const byRelativeChannel = new Map((existingValues || []).map((v) => [Number(v.relative_channel), Number(v.value)]));
  return (channels || [])
    .slice()
    .sort((a, b) => a.relative_channel - b.relative_channel)
    .map((c) => ({
      relative_channel: c.relative_channel,
      function_name: c.function_name,
      value: byRelativeChannel.has(c.relative_channel) ? byRelativeChannel.get(c.relative_channel) : 0,
    }));
}

class DmxDevicePresetForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: JSON.parse(localStorage.getItem('authUser')),
      name: '',
      channelValues: [],
      popup: false,
      pop_msg: '',
      alertType: '',
    };
    this.handleValidSubmit = this.handleValidSubmit.bind(this);
  }

  componentDidMount() {
    const { user } = this.state;
    const { device, presetId } = this.props;
    this.props.getDmxProfileById(user, device.profile_id);
    if (presetId) {
      this.props.getDmxDevicePresetById(user, device.id, presetId);
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.profileDetail && this.props.profileDetail !== prevProps.profileDetail) {
      this.setState({ channelValues: buildChannelValues(this.props.profileDetail.channels, this.state.presetValuesLoaded) });
    }

    if (this.props.presetDetail && this.props.presetDetail !== prevProps.presetDetail) {
      this.setState({
        name: this.props.presetDetail.name,
        presetValuesLoaded: this.props.presetDetail.values,
        channelValues: buildChannelValues(
          (this.props.profileDetail && this.props.profileDetail.channels) || [],
          this.props.presetDetail.values,
        ),
      });
    }

    const { createDmxDevicePresetError, loadingCreateDmxDevicePreset, messageDmxDevicePreset: msgCreate } = this.props;
    if (loadingCreateDmxDevicePreset === false && prevProps.loadingCreateDmxDevicePreset === true) {
      if (createDmxDevicePresetError) {
        this.setState({
          popup: true,
          pop_msg: createDmxDevicePresetError.message || 'Error al crear el preset',
          alertType: 'error',
        });
      } else if (msgCreate) {
        this.setState({ popup: true, pop_msg: 'Preset creado correctamente', alertType: 'correct' });
      }
    }

    const { updateDmxDevicePresetError, loadingUpdateDmxDevicePreset, messageDmxDevicePreset: msgUpdate } = this.props;
    if (loadingUpdateDmxDevicePreset === false && prevProps.loadingUpdateDmxDevicePreset === true) {
      if (updateDmxDevicePresetError) {
        this.setState({
          popup: true,
          pop_msg: updateDmxDevicePresetError.message || 'Error al modificar el preset',
          alertType: 'error',
        });
      } else if (msgUpdate) {
        this.setState({ popup: true, pop_msg: 'Preset modificado correctamente', alertType: 'correct' });
      }
    }
  }

  confirmPopup() {
    const wasSuccess = this.state.alertType === 'correct';
    this.setState({ popup: false });
    if (wasSuccess) {
      this.props.onSaved();
    }
  }

  onChannelValueChange(relative_channel, rawValue) {
    let value = Number(rawValue);
    if (Number.isNaN(value)) value = 0;
    if (value < 0) value = 0;
    if (value > 255) value = 255;
    this.setState({
      channelValues: this.state.channelValues.map((c) => (c.relative_channel === relative_channel ? { ...c, value } : c)),
    });
  }

  handleValidSubmit(event, values) {
    const { user, channelValues } = this.state;
    const { device, presetId } = this.props;
    const preset = {
      id: presetId || undefined,
      deviceId: device.id,
      name: values.name,
      values: channelValues.map((c) => ({ relative_channel: c.relative_channel, value: c.value })),
      token: user.token,
    };
    if (presetId) {
      this.props.updateDmxDevicePreset(preset);
    } else {
      this.props.createDmxDevicePreset(preset);
    }
  }

  render() {
    const { presetId } = this.props;
    const { channelValues } = this.state;
    if (!channelValues.length) return null;

    return (
      <Col lg="12">
        <Card>
          <CardBody>
            <CardTitle className="mb-4">{presetId ? this.props.t('Editar preset') : this.props.t('Crear preset')}</CardTitle>
            <AvForm className="needs-validation" onValidSubmit={this.handleValidSubmit}>
              <Col>
                <FormGroup>
                  <Label htmlFor="presetName">{this.props.t('Nombre')}</Label>
                  <AvField
                    value={this.state.name}
                    name="name"
                    type="text"
                    className="form-control"
                    validate={{ required: { value: true } }}
                    id="presetName"
                  />
                </FormGroup>
              </Col>

              <Table className="table-centered table-nowrap mb-0">
                <thead>
                  <tr>
                    <th>{this.props.t('Canal')}</th>
                    <th>{this.props.t('Función')}</th>
                    <th>{this.props.t('Valor (0-255)')}</th>
                  </tr>
                </thead>
                <tbody>
                  {channelValues.map((c) => (
                    <tr key={c.relative_channel}>
                      <td>{c.relative_channel}</td>
                      <td>{c.function_name}</td>
                      <td>
                        <input
                          type="number"
                          min="0"
                          max="255"
                          className="form-control"
                          value={c.value}
                          onChange={(e) => this.onChannelValueChange(c.relative_channel, e.target.value)}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>

              <FormGroup className="mt-3">
                <Button color="secondary" type="submit" className="buttonStatus mt-2">
                  {this.props.t('Guardar cambios')}
                </Button>
                <Button color="light" type="button" className="buttonStatus mt-2 ml-2" onClick={() => this.props.onClose()}>
                  {this.props.t('Cancelar')}
                </Button>
              </FormGroup>
            </AvForm>

            {this.state.popup ? (
              <SweetAlert
                type={this.state.alertType === 'correct' ? 'success' : 'error'}
                confirmBtnBsStyle={this.state.alertType === 'correct' ? 'success' : 'danger'}
                title={this.state.pop_msg}
                confirmBtnText={this.props.t('ok')}
                onConfirm={() => this.confirmPopup()}
              ></SweetAlert>
            ) : null}
          </CardBody>
        </Card>
      </Col>
    );
  }
}

const mapStateToProps = (state) => {
  const { profile: profileDetail } = state.getDmxProfileById;
  const { preset: presetDetail } = state.getDmxDevicePresetById;
  const {
    createDmxDevicePresetError,
    loadingCreateDmxDevicePreset,
    messageDmxDevicePreset: msgCreate,
  } = state.createDmxDevicePreset;
  const {
    updateDmxDevicePresetError,
    loadingUpdateDmxDevicePreset,
    messageDmxDevicePreset: msgUpdate,
  } = state.updateDmxDevicePreset;
  return {
    profileDetail,
    presetDetail,
    createDmxDevicePresetError,
    loadingCreateDmxDevicePreset,
    updateDmxDevicePresetError,
    loadingUpdateDmxDevicePreset,
    messageDmxDevicePreset: msgCreate || msgUpdate,
  };
};

export default withRouter(
  connect(mapStateToProps, {
    getDmxProfileById,
    getDmxDevicePresetById,
    createDmxDevicePreset,
    updateDmxDevicePreset,
  })(withNamespaces()(DmxDevicePresetForm)),
);
